import { reactive } from 'vue';

export const criarTpDoc = () => {
  return reactive({
    id: 0,
    idep: 0,
    idtpdocgrupo: 0,
    cdtpdoc: 0,
    nmtpdoc: '',
    detalhamento: '',
    ativo: 'S',
    ckobrigatorio: 'N',
    ckvalidade: 'S',
    ckverificacao: 'S',
    idlogin: 0
  });
};